import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaFcFa.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(VM)$/.test(type)
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'VM'},
            ]
        },

        _fixChild(map, node, child) {
            return map.BizNode.VM._fixChild(map, node, child)
        },
    })
}
